module.exports = __webpack_public_path__ + "img/quirion.4a1a88d.jpg";